export default "__VITE_ASSET__Bd9rUFPW__$_?url__"